import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { ProtectedRoute, PublicRoute } from './components/ProtectedRoute'
import Layout from './components/Layout'
import LoginPage from './pages/LoginPage'
import LandingPage from './pages/LandingPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import ClientSetupPage from './pages/ClientSetupPage'
import CpaDashboard from './pages/CpaDashboard'
import ClientDashboard from './pages/ClientDashboard'
import ClientsPage from './pages/ClientsPage'
import ClientProfilePage from './pages/ClientProfilePage'
import DocumentsPage from './pages/DocumentsPage'
import DocumentAnalyzerPage from './pages/DocumentAnalyzerPage'
import RemindersPage from './pages/RemindersPage'
import BillingPage from './pages/BillingPage'
import PaymentPlansPage from './pages/PaymentPlansPage'
import RecurringInvoicesPage from './pages/RecurringInvoicesPage'
import ReportsPage from './pages/ReportsPage'
import RevenueDashboard from './pages/RevenueDashboard'
import YearOverYearPage from './pages/YearOverYearPage'
import OrganizerPage from './pages/OrganizerPage'
import MessagingPage from './pages/MessagingPage'
import ContactsPage from './pages/ContactsPage'
import CalendarPage from './pages/CalendarPage'
import EngagementLetterPage from './pages/EngagementLetterPage'
import DrakeExportPage from './pages/DrakeExportPage'
import AuditLogPage from './pages/AuditLogPage'
import SettingsPage from './pages/SettingsPage'
import IntegrationsPage from './pages/IntegrationsPage'
import ProposalBuilderPage from './pages/ProposalBuilderPage'
import ClientInvoicesPage from './pages/ClientInvoicesPage'
import EngagementSigningPage from './pages/EngagementSigningPage'
import EngagementsPage from './pages/EngagementsPage'
import DocumentEditorPage from './pages/DocumentEditorPage'
import SignDocumentsPage from './pages/SignDocumentsPage'
import './index.css'
import './executive.css'

function DashboardRouter() {
  const { isCPA } = useAuth()
  return isCPA ? <CpaDashboard /> : <ClientDashboard />
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/client-setup" element={<ClientSetupPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/dashboard"              element={<DashboardRouter />} />
                  <Route path="/clients"                element={<ClientsPage />} />
                  <Route path="/clients/:id"            element={<ClientProfilePage />} />
                  <Route path="/clients/:id/profile"    element={<ClientProfilePage />} />
                  <Route path="/documents"              element={<DocumentsPage />} />
                  <Route path="/doc-analyzer"           element={<DocumentAnalyzerPage />} />
                  <Route path="/reminders"              element={<RemindersPage />} />
                  <Route path="/invoices"               element={<BillingPage />} />
                  <Route path="/billing"                element={<BillingPage />} />
                  <Route path="/payment-plans"          element={<PaymentPlansPage />} />
                  <Route path="/recurring-invoices"     element={<RecurringInvoicesPage />} />
                  <Route path="/reports"                element={<ReportsPage />} />
                  <Route path="/revenue"                element={<RevenueDashboard />} />
                  <Route path="/year-over-year"         element={<YearOverYearPage />} />
                  <Route path="/organizer"              element={<OrganizerPage />} />
                  <Route path="/messages"               element={<MessagingPage />} />
                  <Route path="/contacts"               element={<ContactsPage />} />
                  <Route path="/calendar"               element={<CalendarPage />} />
                  <Route path="/engagement-letter"      element={<EngagementLetterPage />} />
                  <Route path="/engagements"            element={<EngagementsPage />} />
                  <Route path="/drake-export"           element={<DrakeExportPage />} />
                  <Route path="/audit-log"              element={<AuditLogPage />} />
                  <Route path="/settings"               element={<SettingsPage />} />
                  <Route path="/integrations"           element={<IntegrationsPage />} />
                  <Route path="/proposal-builder"       element={<ProposalBuilderPage />} />
                  <Route path="/my-documents"           element={<DocumentsPage />} />
                  <Route path="/my-messages"            element={<MessagingPage />} />
                  <Route path="/my-invoices"            element={<ClientInvoicesPage />} />
                  <Route path="/signature"              element={<Navigate to="/sign-documents" replace />} />
                  <Route path="/engagement-signing"     element={<EngagementSigningPage />} />
                  <Route path="/document-editor/:documentId" element={<DocumentEditorPage />} />
                  <Route path="/sign-documents"         element={<SignDocumentsPage />} />
                  <Route path="*"                       element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
